import { AnyDocument, WorkflowState } from '../../../types';
import { InceptHeader } from '../../constants/InceptHeader';
import { buildIncludeParams } from '../../logic/buildIncludeParams';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';

export const getDocument = async (
  constructGet: ConstructGet,
  documentId: string,
  definitionName: string,
  includes?: string[],
  workflowName?: string,
): Promise<NonPaginatedResponse<AnyDocument, WorkflowState> | undefined> =>
  constructGet(`${DOCUMENTS_BASE_PATH}/${documentId}`, {
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
      // Send the workflow so the API can return the document's currentPlace (and
      // enabledTransitions/flags) for it in the response meta. Without this the
      // backend cannot resolve the workflow and omits the workflow metadata.
      ...(workflowName && { [InceptHeader.WorkflowName]: workflowName }),
    },
    params: buildIncludeParams(includes),
  });
